import bytes from 'bytes';
import { FileWithPreview } from './types';
import clsx from 'clsx';
import { KTSVG } from '../../../../_metronic/helpers';

interface Props {
  file: FileWithPreview;
  onRemove: () => void;
  containerClassName?: React.HTMLAttributes<HTMLDivElement>['className'];
  width?: string;
  height?: string;
}

export default function MiniImagePreview({
  file,
  onRemove,
  containerClassName,
  width = '100%',
  height = '100%',
}: Props) {
  return (
    <div
      key={file.name}
      className={clsx('position-relative', containerClassName)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <img
        src={file.preview}
        onLoad={() => {
          URL.revokeObjectURL(file.preview);
        }}
        className={clsx('rounded-xl')}
        style={{ objectFit: 'cover', width: width, height: height }}
      />
      <div
        className='btn btn-dark bg-dark bg-opacity-75 position-absolute start-100 translate-middle fs-9 m-0'
        style={{
          top: '5%',
          padding: '2px 4px',
        }}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <KTSVG className='svg-icon-7 m-0' path='/media/icons/duotune/arrows/arr061.svg' />
      </div>
    </div>
  );
}
